import { css } from 'styled-components'
import { transitions } from '~theme'
import { DURATION_MODIFIER } from './Animations.consts'
import { Animatable } from './Animations.types'

export const fade = css<Animatable>`
  ${props =>
    props.isShown &&
    css`
      opacity: 1;
    `}
  ${props =>
    !props.isShown &&
    css`
      opacity: 0;
    `}
  ${transitions(['opacity'], DURATION_MODIFIER)}
`

const fadeCommonStyles = css<Animatable>`
  ${fade};
  ${props =>
    props.isShown &&
    css`
      transform: translate3d(0, 0, 0);
    `}
  ${transitions(['transform', 'opacity'], DURATION_MODIFIER)}
`

export const fadeLeft = css<Animatable>`
  ${fadeCommonStyles};

  ${props =>
    !props.isShown &&
    css`
      transform: translate3d(-100%, 0, 0);
    `}
`

export const fadeRight = css<Animatable>`
  ${fadeCommonStyles};

  ${props =>
    !props.isShown &&
    css`
      transform: translate3d(100%, 0, 0);
    `}
`

export const fadeTop = css<Animatable>`
  ${fadeCommonStyles};

  ${props =>
    !props.isShown &&
    css`
      transform: translate3d(0, -100%, 0);
    `}
`

export const fadeBottom = css<Animatable>`
  ${fadeCommonStyles};

  ${props =>
    !props.isShown &&
    css`
      transform: translate3d(0, 100%, 0);
    `}
`
